'use client';
import useAspidaSWR from '@aspida/swr';
import { useContext, useEffect } from 'react';
import { apiClient } from '~/lib/apiClient';
import { isActiveToken } from '~/src/services/users';
import { RootContext } from '~/store';
import { GrantedItem } from '~/types/resources/grantedItem';

type UseGrantedItem = {
  grantedItem?: GrantedItem;
};

export const useGrantedItem = (gacha_id: string | null): UseGrantedItem => {
  const { token } = useContext(RootContext);

  const { data, mutate } = useAspidaSWR(apiClient.v1.me.granted_prizes, {
    headers: {
      Authorization: `Bearer ${token?.token}`,
    },
    query: {
      gacha_id: gacha_id as string,
    },
    isPaused: () => !isActiveToken(token) || gacha_id == null,
  });

  useEffect(() => {
    mutate();
  }, [token]);

  return {
    grantedItem: data,
  };
};
